var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#083DAF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.5,14.4C398.4,5.5,388.8,0,378.6,0H271.5v126.6h196.9L403.5,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,0H133.4c-10.3,0-19.8,5.5-24.9,14.4L43.8,126.6h197.7L241.5,0L241.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,156.6v320.1c0,19.5,15.8,35.3,35.3,35.3h375.3c19.5,0,35.3-15.8,35.3-35.3V156.6H33.1z M324.1,291.2 l-77.6,77.6c-2.9,2.9-6.8,4.4-10.6,4.4s-7.7-1.5-10.6-4.4l-36.4-36.4c-5.9-5.9-5.9-15.4,0-21.2c5.9-5.9,15.4-5.9,21.2,0 l25.8,25.8l67-67c5.9-5.9,15.4-5.9,21.2,0C330,275.9,330,285.4,324.1,291.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentBlue);
export default __webpack_public_path__ + "static/media/sent_blue.eee352b2b5e3566d36580386040ddaee.svg";
export { ForwardRef as ReactComponent };